<template>
  <div v-loading='loading' class='gPageBorder'>
    <!-- <el-row :gutter="20" style="margin-bottom: 20px;">

          <el-col :span="4">

            <el-select @change='selectChange' style='' v-model="fType" clearable :placeholder="$t('app_select')">
            <el-option
              v-for="item in $firmwareTypes"
              :key="item.vl"
              :label="item.label"
              :value="item.vl">
            </el-option>
          </el-select>

      </el-col>
      <el-col :span="8">
            <el-input
              :placeholder="$t('lin_global.tgmccz')"
            v-model="qName"
            @keyup.enter.native="search">
          </el-input>
          </el-col>
          <el-button type='primary' @click='search'>{{$t('app_query')}}</el-button>
    </el-row>
    <el-col :span="2" :offset="0" style='margin-bottom:10px;'>
      <el-button style='width:80px;' type="primary" @click="upload" icon="">{{$t('lin_global.upload')}}</el-button>
    </el-col> -->
     <el-table
      @row-click='check'
      :data="tableData"
      border
      style="width: 100%;"
      class='tbPoint'
      ref="arrdata">
        <el-table-column
        prop="firmwareName"
        :label="$t('lin_global.name')">
        </el-table-column>
        <el-table-column
        prop="version"
        :label="$t('lin_global.version')"
        width="120">
        </el-table-column>
        <!--<el-table-column
        prop="status"
        label="状态"
        width="150"
        :formatter="formatStatus">
        </el-table-column>-->
       <el-table-column
         :label="$t('lin_global.status')"
         width="150">
         <template slot-scope="scope">
           <span v-if="scope.row.status == 0" style="color: #8492A6;">{{$t('lin_global.waitOne')}}</span>
           <span v-if="scope.row.status == 1" style="color: #F7BA2A;">{{$t('lin_global.waitTwo')}}</span>
           <span v-if="scope.row.status == 2" style="color:#13CE66;">{{$t('lin_global.verifyPass')}}</span>
           <span v-if="scope.row.status == 3" style="color: #FF4949;">{{$t('lin_global.verifyNotPass')}}</span>
         </template>
       </el-table-column>
        <el-table-column
        prop="type"
        :label="$t('terminal.details.animatType')"
        width="100">
        </el-table-column>
        <el-table-column
        prop="mechanismName"
        :label="$t('lin_global.label_areaid')">
        </el-table-column>
        <el-table-column
        prop="downloads"
        :label="$t('lin_global.downNumber')"
        width="">
        </el-table-column>
        <el-table-column
          :label="$t('lin_global.ope')" width="180">
        <template slot-scope='scope'>
          <!-- <el-button @click="" type=text>{{$t('app_verify')}}</el-button> -->
          <el-tooltip class="item" effect="dark" :content="$t('app_verify')" placement="top">
            <el-button type='text'><i class="fa fa-check-square-o" style=""></i></el-button>
          </el-tooltip>
        </template>
        </el-table-column>
      </el-table>
      <div class='gPgDiv'>
      <el-pagination
        @size-change="pageSized"
        class='gPg'
        @current-change="handleCurrentChange"
        :current-page="index"
        :page-sizes="$gRows"
        :page-size="$gRow"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  export default{
    data(){
      return{
        mechanismId: window.localStorage['mechanismId'],
        loading: 0,
        fType:'',
        tableData:[],
        total: 0,
        qName:'',
        type: [{
              value: '',
              label: this.$t('lin_global.allType')
            }, {
              value: 'ota',
              label: 'OTA'
            }, {
              value: 'rom',
              label: 'ROM'
          }]
      }
    },
    computed: {
      index () {
        return this.$getWPage('firmwarePage')
      }
    },
    mounted(){
      // console.log(this.fTypes)
      this.getList()
    },
    methods:{
      check (row) {
        // console.log(row)
        this.$setWObj('info', row)
        this.$router.push({path: 'firmwareCheck/detail'})
      },
      delFw(row) {
        this.$showConfirm(this.$t('app_tip'), this.$t('app_tipAppEdit'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', () => {
          this.loading = 1
          this.$delFirmware(ids, (res) => {
            this.loading = 0
            if (res.status === 200) {
              this.$message.success(res.message)
              this.getList()
            } else {
              this.$message.error(res.message)
            }
          }, () => {
            this.loading = 0
          })
        }, '') 
      },
      editFw(row) {
        this.$setWObj('info', row)
        this.$router.push({path: 'firmwareManage/edit'})
      },
      submitFw(row) {
        this.$showConfirm(this.$t('app_tip'), this.$t('app_isSubmitToCheck'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', () => {
          this.loading = 1
          this.$checkFirmware(row.id, '', '1', (res) => {
            this.loading = 0
            if (res.status === 200) {
              this.$message.success(res.message)
              this.getList()
            } else {
              this.$message.error(res.message)
            }
          }, () => {
            this.loading = 0
            // error
          })
        }, '') 
      },
      search () {
        this.getList()
      },
      selectChange () {
        this.getList()
      },
      pageSized (val) {
        this.$gRow = val
        this.getList()
      },
      submitRow:function(id){
        let token = localStorage.getItem('user');
        var params = {token:token,ota_rom_id:id,content:'',status:1};
        this.$confirm(this.$t('lin_global.qdtjsh'), this.$t('lin_btn.tips'), {
              confirmButtonText: this.$t('lin_btn.confirm'),
              cancelButtonText: this.$t('lin_btn.cancel'),
              type: 'warning'
            }).then(() => {
          axios.post(`${baseurl}/ota_rom/audit.do`,params).then(res=>{
            //console.log("提交审核返回参数")
            //console.log(res.data)
                  if (res.data.status == 200) {
                    this.$message.success(this.$t('lin_global.tjshcg'))
                    this.getData(1,'')
                  } else {
                    this.$message.error(res.data.message)
                  }
              })
            }).catch(() => {

        })
      },
      editRow:function(id){
        this.$router.push({ path: '/romList/'+id+'/edit' })
      },
      deleteRow:function(id){
        var params = {ids:id}
        this.$confirm(this.$t('lin_global.confirmDelete'), this.$t('lin_btn.tips'), {
              confirmButtonText: this.$t('lin_btn.confirm'),
              cancelButtonText: this.$t('lin_btn.cancel'),
              type: 'warning'
            }).then(() => {
              axios.post(`${baseurl}/ota_rom/delete.do`,params).then(res=>{
                if (res.data.status == 200) {
                  this.$message.success(this.$t('lin_global.delete_success'))
                  this.getData(1,'')
                } else {
                  this.$message.error(res.data.message)
                }
              })
            }).catch(() => {

        })
      },
      getList () {
        this.loading = 1
        var type = this.fType ? this.fType : ''
        var name = this.qName ? this.qName : ''
        var status = '1'
        this.$getFirmwareList(this.$gRow, this.$getWPage('firmwarePage'), this.mechanismId, name, type, status, (res) => {
          console.log('res', res)
          this.loading = 0
          if (res.status === 200) {
            this.total = res.total
            this.tableData = res.data
          } else {
            this.$message(res.message)
          }
        }, () => {
          this.loading = 0
          this.$message.error(this.$t('app_rqsError'))
        })
      },
      upload:function(){
        this.$router.push({path:'firmwareManage/upload'})
      },
      handleIconClick:function(){
      },
      handleSizeChange: function (val) {
            
      },
      handleCurrentChange: function (index) {
        this.$setWPage('firmwarePage', index)
        this.getList()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// check.vue?be2c2c18